import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Eye } from "lucide-react"
import type { ReactNode } from "react"

/** A form with a live preview of what it produces beside it (below it on a
 *  narrow screen). The preview follows the edits as they are typed. */
export function SettingsWithPreview({
  preview,
  children,
}: {
  preview: ReactNode
  children: ReactNode
}) {
  const { translate } = useTranslation()
  return (
    <div className="grid items-start gap-8 xl:grid-cols-[minmax(0,1fr)_minmax(0,22rem)]">
      <div className="flex min-w-0 flex-col gap-6">{children}</div>
      <aside className="flex flex-col gap-2 xl:sticky xl:top-0">
        <Typography as="muted" className="flex items-center gap-1.5">
          <Eye className="size-3.5" />
          {translate("MC_TPL_PREVIEW")}
        </Typography>
        {preview}
      </aside>
    </div>
  )
}
